module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"Share":"Share","Scan to Watch":"Scan to Watch","Save QR Code":"Save QR Code","Copy":"Copy"},"zh":{"Share":"分享给好友","Scan to Watch":"扫码观看","Save QR Code":"保存图片","Copy":"复制"}}')
  delete Component.options._Ctor
}
